import { apiRequest } from "@/server/request";
import type {
  Response,
  UserLoginRequest,
  LoginResponse,
  EmailRegisterPayload,
  EmailLoginPayload,
  EmailLoginByCodePayload,
  EmailAuthResponse,
  SendEmailCodePayload,
  SendPasswordResetCodePayload,
  ResetPasswordPayload,
  EmailWithdrawRequest,
  EmailWithdrawResponse,
  UserInfoResponse,
  FortAgentPurchaseSignRequest,
  FortAgentPurchaseSignResponse,
  FortAgentTransferSignRequest,
  FortAgentTransferSignResponse,
  FortAgentActivateSignRequest,
  FortAgentActivateSignResponse,
  FortAgentPayMixedFusdRequest,
  FortAgentPayMixedFusdResponse,
  GetFortAgentSkuConfigResponse,
  GetMyFortAgentsResponse,
  GetLpInfoResponse,
  GetAIFTokenPriceRequest,
  GetAIFTokenPriceResponse,
  PlatFormResponse,
  SubmitWithdrawOrDepositTxResponse,
  SubmitWithdrawOrDepositTxRequest,
  GetBalanceV2Response,
  GetUserInviteLevelResponse,
  GetInviteLevelConfigRequest,
  GetInviteLevelConfigResponse,
  GetUserInviteTeamRequest,
  GetUserInviteTeamResponse,
  GetUserDirectTeamAiRevenueRequest,
  GetUserDirectTeamAiRevenueResponse,
  GetUserDynamicRewardInfoRequest,
  GetUserDynamicRewardInfoResponse,
  GetUserDynamicRewardDailyRecordsRequest,
  GetUserDynamicRewardDailyRecordsResponse,
  GetUserDynamicRewardClaimRecordsRequest,
  GetUserDynamicRewardClaimRecordsResponse,
  ClaimDynamicRewardRequest,
  ClaimDynamicRewardResponse,
  CreateDynamicRewardClaimBridgeSignRequest,
  CreateDynamicRewardClaimBridgeSignResponse,
  CreateCustodyClaimBridgeSignRequest,
  CreateCustodyClaimBridgeSignResponse,
  GetWithdrawAndRechargeRecordRequest,
  GetWithdrawAndRechargeRecordResponse,
  BalanceSwapRequest,
  BalanceSwapResponse,
  TransferFusdRequest,
  TransferFusdResponse,
  GetOpenOrderListRequest,
  GetOpenOrderListResponse,
  GetClosedOrderListRequest,
  GetClosedOrderListResponse,
  GetBinanceSpotEthBtcQuoteResponse,
  GetRiskListResponse,
  EstimateOrderFeesRequest,
  EstimateOrderFeesResponse,
  PlaceOrderRequest,
  PlaceOrderResponse,
  ClosePositionRequest,
  ClosePositionResponse,
  GetUserCexPnlSummaryRequest,
  GetUserCexPnlSummaryResponse,
  GetAiLossCompNextPeriodProgressRequest,
  GetAiLossCompNextPeriodProgressResponse,
  GetAiLossCompStaticPayoutRecordsRequest,
  GetAiLossCompStaticPayoutRecordsResponse,
  GetCexFeeRecordListRequest,
  GetCexFeeRecordListResponse,
  GetUserCexOrderTradeStatsRequest,
  GetUserCexOrderTradeStatsResponse,
  GetPlatformCexSymbolDayStatsRequest,
  GetPlatformCexSymbolDayStatsResponse,
  GetSignalRequest,
  GetSignalResponse,
  EstimateSignalPrechargeRequest,
  EstimateSignalPrechargeResponse,
  GetDepositRecipientRequest,
  GetDepositRecipientResponse,
  GetCustodyConfigResponse,
  GetCustodyOrdersRequest,
  GetCustodyOrdersResponse,
  GetUserCustodyInfoResponse,
  SignCustodyAgreementRequest,
  SignCustodyAgreementResponse,
  CustodyDepositRequest,
  CustodyDepositResponse,
  CustodyExitRequest,
  CustodyExitResponse,
  CustodyClaimRequest,
  CustodyClaimResponse,
  CustodyReinvestRequest,
  CustodyReinvestResponse,
  GetCustodyDailyPayoutRecordsRequest,
  GetCustodyDailyPayoutRecordsResponse,
  GetCustodyStaticClaimLinesRequest,
  GetCustodyStaticClaimLinesResponse,
  GetCustodyExitRecordsRequest,
  GetCustodyExitRecordsResponse,
  GetCexAutoTradeUserSettingRequest,
  GetCexAutoTradeUserSettingResponse,
  SetCexAutoTradeSwitchRequest,
  SetCexAutoTradeSwitchResponse,
  GetHlAutoMarginAccountRequest,
  GetHlAutoMarginAccountResponse,
  TransferInRequest,
  TransferOutRequest,
  TransferResponse,
  SetHlAutoTradeSwitchRequest,
  SetHlAutoTradeSwitchResponse,
  GetUserContactProfileRequest,
  GetUserContactProfileResponse,
  SetUserContactProfileRequest,
  SetUserContactProfileResponse,
  GetFortAgentStaticPayoutRecordsRequest,
  GetFortAgentStaticPayoutRecordsResponse,
  GetFortAgentAifVestingPayoutRecordsRequest,
  GetFortAgentAifVestingPayoutRecordsResponse,
  ReportClientErrorRequest,
  ReportClientErrorResponse,
  GetNoticeRecordListRequest,
  GetNoticeRecordListResponse,
  GetNoticeRecordDetailRequest,
  GetNoticeRecordDetailResponse,
} from "./types";

// ===================== 用户/登录 =====================

export const ApiLogin = (
  data: UserLoginRequest
): Promise<Response<LoginResponse>> => {
  return apiRequest<LoginResponse>({
    url: "/user/login/Login",
    method: "post",
    data,
  });
};

/** 发送邮箱验证码 `POST /game/account/SendEmailCode` */
export const ApiSendEmailCode = (
  payload: SendEmailCodePayload
): Promise<Response<EmailAuthResponse>> => {
  return apiRequest<EmailAuthResponse>({
    url: "/game/account/SendEmailCode",
    method: "post",
    data: payload,
  });
};

/** 发送重置密码验证码 `POST /game/account/SendPasswordResetCode` */
export const ApiSendPasswordResetCode = (
  payload: SendPasswordResetCodePayload
): Promise<Response<EmailAuthResponse>> => {
  return apiRequest<EmailAuthResponse>({
    url: "/game/account/SendPasswordResetCode",
    method: "post",
    data: payload,
  });
};

/** 重置密码 `POST /game/account/ResetPassword` */
export const ApiResetPassword = (
  payload: ResetPasswordPayload
): Promise<Response<EmailAuthResponse>> => {
  return apiRequest<EmailAuthResponse>({
    url: "/game/account/ResetPassword",
    method: "post",
    data: payload,
  });
};

/** 邮箱注册 `POST /game/account/Register`（免 token，信封 `{ data: {...} }`） */
export const ApiEmailRegister = (
  payload: EmailRegisterPayload
): Promise<Response<EmailAuthResponse>> => {
  return apiRequest<EmailAuthResponse>({
    url: "/game/account/Register",
    method: "post",
    data: payload,
  });
};

/** 邮箱登录 `POST /game/account/Login` */
export const ApiEmailLogin = (
  payload: EmailLoginPayload
): Promise<Response<EmailAuthResponse>> => {
  return apiRequest<EmailAuthResponse>({
    url: "/game/account/Login",
    method: "post",
    data: payload,
  });
};

/** 邮箱验证码登录 `POST /game/account/LoginByCode` */
export const ApiEmailLoginByCode = (
  payload: EmailLoginByCodePayload
): Promise<Response<EmailAuthResponse>> => {
  return apiRequest<EmailAuthResponse>({
    url: "/game/account/LoginByCode",
    method: "post",
    data: payload,
  });
};

/** 邮箱托管提现 `POST /game/account/Withdraw`（需 token） */
export const ApiEmailAccountWithdraw = (
  data: EmailWithdrawRequest
): Promise<Response<EmailWithdrawResponse>> => {
  return apiRequest<EmailWithdrawResponse>({
    url: "/game/account/Withdraw",
    method: "post",
    data,
  });
};

export const ApiGetUserInfo = (): Promise<Response<UserInfoResponse>> => {
  return apiRequest<UserInfoResponse>({
    url: "/game/user/GetUserInfo",
    method: "post",
    data: {},
  });
};

/** 前端错误上报（/game/user/ReportClientError） */
export const ApiReportClientError = (
  data: ReportClientErrorRequest
): Promise<Response<ReportClientErrorResponse>> => {
  return apiRequest<ReportClientErrorResponse>({
    url: "/game/user/ReportClientError",
    method: "post",
    data,
  });
};

/** 获取用户联系信息（收货地址） */
export const ApiGetUserContactProfile = (
  data: GetUserContactProfileRequest = {}
): Promise<Response<GetUserContactProfileResponse>> => {
  return apiRequest<GetUserContactProfileResponse>({
    url: "/game/user/GetUserContactProfile",
    method: "post",
    data,
  });
};

/** 设置用户联系信息（收货地址） */
export const ApiSetUserContactProfile = (
  data: SetUserContactProfileRequest
): Promise<Response<SetUserContactProfileResponse>> => {
  return apiRequest<SetUserContactProfileResponse>({
    url: "/game/user/SetUserContactProfile",
    method: "post",
    data,
  });
};

/** 获取充值收款地址 */
export const ApiGetDepositRecipient = (
  data: GetDepositRecipientRequest = {}
): Promise<Response<GetDepositRecipientResponse>> => {
  return apiRequest<GetDepositRecipientResponse>({
    url: "/game/user/GetDepositRecipient",
    method: "post",
    data,
  });
};

export const ApiGetLpInfo = (
  token0Contract: string,
  token1Contract: string
): Promise<Response<GetLpInfoResponse>> => {
  return apiRequest({
    url: "/game/user/GetLpInfo",
    method: "post",
    data: {
      token0Contract,
      token1Contract,
    },
  });
};

/**
 * 获取 AIF/TSK 代币行情（来自后端聚合数据，区别于链上 LP 即时报价）。
 * 返回 `item` 包含当前价格、24h 涨跌幅、市值与更新时间。
 */
export const ApiGetAIFTokenPrice = (
  data: GetAIFTokenPriceRequest = {} as GetAIFTokenPriceRequest
): Promise<Response<GetAIFTokenPriceResponse>> => {
  return apiRequest<GetAIFTokenPriceResponse>({
    url: "/game/user/GetAIFTokenPrice",
    method: "post",
    data,
  });
};
/**
 * 获取平台配置
 * @returns Promise<Response<PlatFormResponse>>
 */
export const ApiGetPlatFormConfig = (): Promise<Response<PlatFormResponse>> => {
  return apiRequest<PlatFormResponse>({
    url: "/game/user/GetPlatFormConfig",
    method: "post",
    data: {},
  });
};

/** 获取资金托管全局配置（免登录） */
export const ApiGetCustodyConfig = (): Promise<
  Response<GetCustodyConfigResponse>
> => {
  return apiRequest<GetCustodyConfigResponse>({
    url: "/game/user/GetCustodyConfig",
    method: "post",
    data: {},
  });
};

/** 获取托管订单列表 */
export const ApiGetCustodyOrders = (
  data: GetCustodyOrdersRequest
): Promise<Response<GetCustodyOrdersResponse>> => {
  return apiRequest<GetCustodyOrdersResponse>({
    url: "/game/user/GetCustodyOrders",
    method: "post",
    data,
  });
};

/** 获取用户托管汇总 */
export const ApiGetUserCustodyInfo = (): Promise<
  Response<GetUserCustodyInfoResponse>
> => {
  return apiRequest<GetUserCustodyInfoResponse>({
    url: "/game/user/GetUserCustodyInfo",
    method: "post",
    data: {},
  });
};

/** 签署托管须知 */
export const ApiSignCustodyAgreement = (
  data: SignCustodyAgreementRequest
): Promise<Response<SignCustodyAgreementResponse>> => {
  return apiRequest<SignCustodyAgreementResponse>({
    url: "/game/user/SignCustodyAgreement",
    method: "post",
    data,
  });
};

/** 托管入金 */
export const ApiCustodyDeposit = (
  data: CustodyDepositRequest
): Promise<Response<CustodyDepositResponse>> => {
  return apiRequest<CustodyDepositResponse>({
    url: "/game/user/CustodyDeposit",
    method: "post",
    data,
  });
};

/** 托管退出 */
export const ApiCustodyExit = (
  data: CustodyExitRequest
): Promise<Response<CustodyExitResponse>> => {
  return apiRequest<CustodyExitResponse>({
    url: "/game/user/CustodyExit",
    method: "post",
    data,
  });
};

/** 托管收益领取 */
export const ApiCustodyClaim = (
  data: CustodyClaimRequest
): Promise<Response<CustodyClaimResponse>> => {
  return apiRequest<CustodyClaimResponse>({
    url: "/game/user/CustodyClaim",
    method: "post",
    data,
  });
};

/** 托管一键复投 */
export const ApiCustodyReinvest = (
  data: CustodyReinvestRequest
): Promise<Response<CustodyReinvestResponse>> => {
  return apiRequest<CustodyReinvestResponse>({
    url: "/game/user/CustodyReinvest",
    method: "post",
    data,
  });
};

/** 获取托管每日日息发放记录（分页） */
export const ApiGetCustodyDailyPayoutRecords = (
  data: GetCustodyDailyPayoutRecordsRequest
): Promise<Response<GetCustodyDailyPayoutRecordsResponse>> => {
  return apiRequest<GetCustodyDailyPayoutRecordsResponse>({
    url: "/game/user/GetCustodyDailyPayoutRecords",
    method: "post",
    data,
  });
};

/** 获取托管领取/复投流水（分页） */
export const ApiGetCustodyStaticClaimLines = (
  data: GetCustodyStaticClaimLinesRequest
): Promise<Response<GetCustodyStaticClaimLinesResponse>> => {
  return apiRequest<GetCustodyStaticClaimLinesResponse>({
    url: "/game/user/GetCustodyStaticClaimLines",
    method: "post",
    data,
  });
};

/** 获取托管解除记录（退出子明细分页） */
export const ApiGetCustodyExitRecords = (
  data: GetCustodyExitRecordsRequest
): Promise<Response<GetCustodyExitRecordsResponse>> => {
  return apiRequest<GetCustodyExitRecordsResponse>({
    url: "/game/user/GetCustodyExitRecords",
    method: "post",
    data,
  });
};

// ===================== Fort Agent =====================

export const ApiFortAgentPurchaseSign = (
  data: FortAgentPurchaseSignRequest
): Promise<Response<FortAgentPurchaseSignResponse>> => {
  return apiRequest<FortAgentPurchaseSignResponse>({
    url: "/game/user/FortAgentPurchaseSign",
    method: "post",
    data,
  });
};

export const ApiFortAgentTransferSign = (
  data: FortAgentTransferSignRequest
): Promise<Response<FortAgentTransferSignResponse>> => {
  return apiRequest<FortAgentTransferSignResponse>({
    url: "/game/user/FortAgentTransferSign",
    method: "post",
    data,
  });
};

export const ApiFortAgentActivateSign = (
  data: FortAgentActivateSignRequest
): Promise<Response<FortAgentActivateSignResponse>> => {
  return apiRequest<FortAgentActivateSignResponse>({
    url: "/game/user/FortAgentActivateSign",
    method: "post",
    data,
  });
};

/** 混合购延期 FUSD 单独支付（中心化扣款，需先对 {@link formatFortAgentPayMixedFusdMessage} 签名） */
export const ApiFortAgentPayMixedFusd = (
  data: FortAgentPayMixedFusdRequest
): Promise<Response<FortAgentPayMixedFusdResponse>> => {
  return apiRequest<FortAgentPayMixedFusdResponse>({
    url: "/game/user/FortAgentPayMixedFusd",
    method: "post",
    data,
  });
};

export const ApiGetFortAgentSkuConfig = (): Promise<
  Response<GetFortAgentSkuConfigResponse>
> => {
  return apiRequest<GetFortAgentSkuConfigResponse>({
    url: "/game/user/GetFortAgentSkuConfig",
    method: "post",
    data: {},
  });
};

export const ApiGetMyFortAgents = (): Promise<
  Response<GetMyFortAgentsResponse>
> => {
  return apiRequest<GetMyFortAgentsResponse>({
    url: "/game/user/GetMyFortAgents",
    method: "post",
    data: {},
  });
};

/** 专属静态奖励发放记录 */
export const ApiGetFortAgentStaticPayoutRecords = (
  data: GetFortAgentStaticPayoutRecordsRequest
): Promise<Response<GetFortAgentStaticPayoutRecordsResponse>> => {
  return apiRequest<GetFortAgentStaticPayoutRecordsResponse>({
    url: "/game/user/GetFortAgentStaticPayoutRecords",
    method: "post",
    data,
  });
};

/** 权益3（AIF 按日释放）发放记录 */
export const ApiGetFortAgentAifVestingPayoutRecords = (
  data: GetFortAgentAifVestingPayoutRecordsRequest
): Promise<Response<GetFortAgentAifVestingPayoutRecordsResponse>> => {
  return apiRequest<GetFortAgentAifVestingPayoutRecordsResponse>({
    url: "/game/user/GetFortAgentAifVestingPayoutRecords",
    method: "post",
    data,
  });
};
/**
 * 提交充值或提现交易
 * @param data - 提交交易请求参数
 * @returns Promise<Response<SubmitWithdrawOrDepositTxResponse>>
 */
export const ApiGetBalanceV2 = (): Promise<Response<GetBalanceV2Response>> => {
  return apiRequest<GetBalanceV2Response>({
    url: "/game/user/GetBalanceV2",
    method: "post",
    data: {},
  });
};

export const ApiGetUserInviteLevel = (): Promise<
  Response<GetUserInviteLevelResponse>
> => {
  return apiRequest<GetUserInviteLevelResponse>({
    url: "/game/user/GetUserInviteLevel",
    method: "post",
    data: {},
  });
};

/** 获取团队等级配置（各等级业绩门槛等，按代币合约维度） */
export const ApiGetInviteLevelConfig = (
  data: GetInviteLevelConfigRequest
): Promise<Response<GetInviteLevelConfigResponse>> => {
  return apiRequest<GetInviteLevelConfigResponse>({
    url: "/game/user/GetInviteLevelConfig",
    method: "post",
    data,
  });
};

/** 获取团队成员列表（按代币合约维度） */
export const ApiGetUserInviteTeam = (
  data: GetUserInviteTeamRequest
): Promise<Response<GetUserInviteTeamResponse>> => {
  return apiRequest<GetUserInviteTeamResponse>({
    url: "/game/user/GetUserInviteTeam",
    method: "post",
    data,
  });
};

/** 直推子团队 AI 交易盈利、盈利分佣、方案三静态补偿与动态分佣 */
export const ApiGetUserDirectTeamAiRevenue = (
  data: GetUserDirectTeamAiRevenueRequest
): Promise<Response<GetUserDirectTeamAiRevenueResponse>> => {
  return apiRequest<GetUserDirectTeamAiRevenueResponse>({
    url: "/game/user/GetUserDirectTeamAiRevenue",
    method: "post",
    data,
  });
};

export const ApiGetUserDynamicRewardInfo = (
  data: GetUserDynamicRewardInfoRequest
): Promise<Response<GetUserDynamicRewardInfoResponse>> => {
  return apiRequest<GetUserDynamicRewardInfoResponse>({
    url: "/game/user/GetUserDynamicRewardInfo",
    method: "post",
    data,
  });
};

export const ApiGetUserDynamicRewardDailyRecords = (
  data: GetUserDynamicRewardDailyRecordsRequest
): Promise<Response<GetUserDynamicRewardDailyRecordsResponse>> => {
  return apiRequest<GetUserDynamicRewardDailyRecordsResponse>({
    url: "/game/user/GetUserDynamicRewardDailyRecords",
    method: "post",
    data,
  });
};

export const ApiGetUserDynamicRewardClaimRecords = (
  data: GetUserDynamicRewardClaimRecordsRequest
): Promise<Response<GetUserDynamicRewardClaimRecordsResponse>> => {
  return apiRequest<GetUserDynamicRewardClaimRecordsResponse>({
    url: "/game/user/GetUserDynamicRewardClaimRecords",
    method: "post",
    data,
  });
};

/** 一次性领取全部可领团队动态奖励（仅纯 U） */
export const ApiClaimDynamicReward = (
  data: ClaimDynamicRewardRequest = {}
): Promise<Response<ClaimDynamicRewardResponse>> => {
  return apiRequest<ClaimDynamicRewardResponse>({
    url: "/game/user/ClaimDynamicReward",
    method: "post",
    data,
  });
};

/**
 * 创建动态奖励 Team Bridge 签名订单（仅 Team 池的 onlyUsdt + tskValueUsdt）。
 * 返回字段用于调用合约
 * `bridgeContract.claimDynamicRewardPurchase(usdtAmount, tskAmount, orderId, nonce, deadline, signature)`，
 * 交易 value 使用 `claimFeeWei`。
 */
export const ApiCreateDynamicRewardClaimBridgeSign = (
  data: CreateDynamicRewardClaimBridgeSignRequest = {}
): Promise<Response<CreateDynamicRewardClaimBridgeSignResponse>> => {
  return apiRequest<CreateDynamicRewardClaimBridgeSignResponse>({
    url: "/game/user/CreateDynamicRewardClaimBridgeSign",
    method: "post",
    data,
  });
};

/**
 * 创建托管奖励 Bridge 签名订单。
 * 返回字段用于调用合约
 * `bridgeContract.claimCustodyRewardPurchase(usdtAmount, tskAmount, orderId, nonce, deadline, signature)`，
 * 交易 value 使用 `claimFeeWei`。
 */
export const ApiCreateCustodyClaimBridgeSign = (
  data: CreateCustodyClaimBridgeSignRequest = {}
): Promise<Response<CreateCustodyClaimBridgeSignResponse>> => {
  return apiRequest<CreateCustodyClaimBridgeSignResponse>({
    url: "/game/user/CreateCustodyClaimBridgeSign",
    method: "post",
    data,
  });
};

export const ApiGetWithdrawAndRechargeRecord = (
  data: GetWithdrawAndRechargeRecordRequest
): Promise<Response<GetWithdrawAndRechargeRecordResponse>> => {
  return apiRequest<GetWithdrawAndRechargeRecordResponse>({
    url: "/game/user/GetWithdrawAndRechargeRecord",
    method: "post",
    data,
  });
};

export const ApiSubmitWithdrawOrDepositTx = (
  data: SubmitWithdrawOrDepositTxRequest
): Promise<Response<SubmitWithdrawOrDepositTxResponse>> => {
  return apiRequest<SubmitWithdrawOrDepositTxResponse>({
    url: "/game/user/SubmitWithdrawOrDepositTx",
    method: "post",
    data,
  });
};

/**
 * FUSD（及同通道代币）内部转账：需先对 {@link buildTransferFusdSignMessage} 的字符串做钱包签名再提交。
 * 后端路径以服务端为准，若不一致请改 `url`。
 */
export const ApiTransferFusd = (
  data: TransferFusdRequest
): Promise<Response<TransferFusdResponse>> => {
  return apiRequest<TransferFusdResponse>({
    url: "/game/user/TransferFusd",
    method: "post",
    data,
  });
};

/** 余额 USDT 兑换 TSK */
export const ApiBalanceUsdtSwapTsk = (
  data: BalanceSwapRequest
): Promise<Response<BalanceSwapResponse>> => {
  return apiRequest<BalanceSwapResponse>({
    url: "/game/user/BalanceUsdtSwapTsk",
    method: "post",
    data,
  });
};

/** 余额 TSK 兑换 USDT */
export const ApiBalanceTskSwapUsdt = (
  data: BalanceSwapRequest
): Promise<Response<BalanceSwapResponse>> => {
  return apiRequest<BalanceSwapResponse>({
    url: "/game/user/BalanceTskSwapUsdt",
    method: "post",
    data,
  });
};

/** 获取当前用户未平仓 CEX 订单（分页） */
export const ApiGetOpenOrderList = (
  data: GetOpenOrderListRequest
): Promise<Response<GetOpenOrderListResponse>> => {
  return apiRequest<GetOpenOrderListResponse>({
    url: "/game/cex/GetOpenOrderList",
    method: "post",
    data,
  });
};

/** 获取当前用户已平仓 CEX 订单（分页） */
export const ApiGetClosedOrderList = (
  data: GetClosedOrderListRequest
): Promise<Response<GetClosedOrderListResponse>> => {
  return apiRequest<GetClosedOrderListResponse>({
    url: "/game/cex/GetClosedOrderList",
    method: "post",
    data,
  });
};

/** 获取 AI 交易风险偏好列表（服务端优先读本地缓存，空则回源并回写） */
export const ApiGetRiskList = (): Promise<Response<GetRiskListResponse>> => {
  return apiRequest<GetRiskListResponse>({
    url: "/game/cex/GetRiskList",
    method: "post",
    data: {},
  });
};

/** 获取 AI 交易信号（/game/cex/GetSignal） */
export const ApiGetSignal = (
  data: GetSignalRequest
): Promise<Response<GetSignalResponse>> => {
  return apiRequest<GetSignalResponse>({
    url: "/game/cex/GetSignal",
    method: "post",
    data,
  });
};

/** 预估当前策略下单手续费（/game/cex/EstimateOrderFees） */
export const ApiEstimateOrderFees = (
  data: EstimateOrderFeesRequest
): Promise<Response<EstimateOrderFeesResponse>> => {
  return apiRequest<EstimateOrderFeesResponse>({
    url: "/game/cex/EstimateOrderFees",
    method: "post",
    data,
  });
};

/**
 * 预估取信号前算力费预扣（/game/cex/EstimateSignalPrecharge）。
 *
 * 取信号名义价（如 2 USDT）将按 FUSD → TSK → USDT 优先级实际扣多少，
 * **不实际扣款**，仅用于前端展示「将扣多少」。
 */
export const ApiEstimateSignalPrecharge = (
  data: EstimateSignalPrechargeRequest = {} as EstimateSignalPrechargeRequest
): Promise<Response<EstimateSignalPrechargeResponse>> => {
  return apiRequest<EstimateSignalPrechargeResponse>({
    url: "/game/cex/EstimateSignalPrecharge",
    method: "post",
    data,
  });
};

/** AI 下单（/game/cex/PlaceOrder） */
export const ApiPlaceOrder = (
  data: PlaceOrderRequest
): Promise<Response<PlaceOrderResponse>> => {
  return apiRequest<PlaceOrderResponse>({
    url: "/game/cex/PlaceOrder",
    method: "post",
    data,
  });
};

/** AI 平仓（/game/cex/ClosePosition） */
export const ApiClosePosition = (
  data: ClosePositionRequest
): Promise<Response<ClosePositionResponse>> => {
  return apiRequest<ClosePositionResponse>({
    url: "/game/cex/ClosePosition",
    method: "post",
    data,
  });
};

/** 获取当前用户 CEX 盈亏汇总（今日 + 累计） */
export const ApiGetUserCexPnlSummary = (
  data: GetUserCexPnlSummaryRequest = {}
): Promise<Response<GetUserCexPnlSummaryResponse>> => {
  return apiRequest<GetUserCexPnlSummaryResponse>({
    url: "/game/cex/GetUserCexPnlSummary",
    method: "post",
    data,
  });
};

/**
 * 当前周期累计（下一期前进度）：
 * 返回 `accumulatedLossUsdt`（周期内累计亏损 U，wei）
 * 与 `accumulatedCompensatedTsk`（周期内已补偿 TSK 数量，token wei）。
 * 替代旧的 `/game/cex/GetUserAutoTradeLossCompPool2Info`。
 */
export const ApiGetAiLossCompNextPeriodProgress = (
  data: GetAiLossCompNextPeriodProgressRequest = {} as GetAiLossCompNextPeriodProgressRequest
): Promise<Response<GetAiLossCompNextPeriodProgressResponse>> => {
  return apiRequest<GetAiLossCompNextPeriodProgressResponse>({
    url: "/game/user/GetAiLossCompNextPeriodProgress",
    method: "post",
    data,
  });
};

/**
 * 方案 3 静态补偿发放记录分页。
 * 替代旧的 `/game/cex/GetUserAutoTradeLossCompPool2Records`。
 */
export const ApiGetAiLossCompStaticPayoutRecords = (
  data: GetAiLossCompStaticPayoutRecordsRequest = {}
): Promise<Response<GetAiLossCompStaticPayoutRecordsResponse>> => {
  return apiRequest<GetAiLossCompStaticPayoutRecordsResponse>({
    url: "/game/user/GetAiLossCompStaticPayoutRecords",
    method: "post",
    data,
  });
};

/** AI 策略交易费用记录列表 */
export const ApiGetCexFeeRecordList = (
  data: GetCexFeeRecordListRequest = {}
): Promise<Response<GetCexFeeRecordListResponse>> => {
  return apiRequest<GetCexFeeRecordListResponse>({
    url: "/game/cex/GetCexFeeRecordList",
    method: "post",
    data,
  });
};

/** 获取当前用户 CEX 自动/手动下单统计（/game/cex/GetUserCexOrderTradeStats） */
export const ApiGetUserCexOrderTradeStats = (
  data: GetUserCexOrderTradeStatsRequest = {}
): Promise<Response<GetUserCexOrderTradeStatsResponse>> => {
  return apiRequest<GetUserCexOrderTradeStatsResponse>({
    url: "/game/cex/GetUserCexOrderTradeStats",
    method: "post",
    data,
  });
};

/** 获取全平台各交易对某业务日的交易量/盈亏汇总（/game/cex/GetPlatformCexSymbolDayStats） */
export const ApiGetPlatformCexSymbolDayStats = (
  data: GetPlatformCexSymbolDayStatsRequest = {}
): Promise<Response<GetPlatformCexSymbolDayStatsResponse>> => {
  return apiRequest<GetPlatformCexSymbolDayStatsResponse>({
    url: "/game/cex/GetPlatformCexSymbolDayStats",
    method: "post",
    data,
  });
};

/** 获取当前用户自动下单开关与统计（/game/cex/GetUserSetting） */
export const ApiGetCexAutoTradeUserSetting = (
  data: GetCexAutoTradeUserSettingRequest = {}
): Promise<Response<GetCexAutoTradeUserSettingResponse>> => {
  return apiRequest<GetCexAutoTradeUserSettingResponse>({
    url: "/game/cex/GetUserSetting",
    method: "post",
    data,
  });
};

/** 开启/关闭自动下单（/game/cex/SetCexAutoTradeSwitch） */
export const ApiSetCexAutoTradeSwitch = (
  data: SetCexAutoTradeSwitchRequest
): Promise<Response<SetCexAutoTradeSwitchResponse>> => {
  return apiRequest<SetCexAutoTradeSwitchResponse>({
    url: "/game/cex/SetCexAutoTradeSwitch",
    method: "post",
    data,
  });
};

/** 查询 HL 自动跟单保证金账户（/game/hlauto/GetHlAutoMarginAccount） */
export const ApiGetHlAutoMarginAccount = (
  data: GetHlAutoMarginAccountRequest = {}
): Promise<Response<GetHlAutoMarginAccountResponse>> => {
  return apiRequest<GetHlAutoMarginAccountResponse>({
    url: "/game/hlauto/GetHlAutoMarginAccount",
    method: "post",
    data,
  });
};

/** 转入 HL 自动跟单保证金（/game/hlauto/TransferIn） */
export const ApiHlAutoTransferIn = (
  data: TransferInRequest
): Promise<Response<TransferResponse>> => {
  return apiRequest<TransferResponse>({
    url: "/game/hlauto/TransferIn",
    method: "post",
    data,
  });
};

/** 转出 HL 自动跟单保证金（/game/hlauto/TransferOut） */
export const ApiHlAutoTransferOut = (
  data: TransferOutRequest
): Promise<Response<TransferResponse>> => {
  return apiRequest<TransferResponse>({
    url: "/game/hlauto/TransferOut",
    method: "post",
    data,
  });
};

/** 设置 HL 自动跟单开关（/game/hlauto/SetHlAutoTradeSwitch） */
export const ApiSetHlAutoTradeSwitch = (
  data: SetHlAutoTradeSwitchRequest
): Promise<Response<SetHlAutoTradeSwitchResponse>> => {
  return apiRequest<SetHlAutoTradeSwitchResponse>({
    url: "/game/hlauto/SetHlAutoTradeSwitch",
    method: "post",
    data,
  });
};

/** 顶部 BTC/ETH：Redis 中币安 24h ticker（game 每 30s 拉取），见 `BinanceSpotQuoteItem` */
export const ApiGetBinanceSpotEthBtcQuote = (): Promise<
  Response<GetBinanceSpotEthBtcQuoteResponse>
> => {
  return apiRequest<GetBinanceSpotEthBtcQuoteResponse>({
    url: "/game/user/GetBinanceSpotEthBtcQuote",
    method: "post",
    data: {},
  });
};

/** 用户端公告列表（/game/user/GetNoticeRecordList） */
export const ApiGetNoticeRecordList = (
  data: GetNoticeRecordListRequest
): Promise<Response<GetNoticeRecordListResponse>> => {
  return apiRequest<GetNoticeRecordListResponse>({
    url: "/game/user/GetNoticeRecordList",
    method: "post",
    data,
  });
};

/** 用户端公告详情（/game/user/GetNoticeRecordDetail） */
export const ApiGetNoticeRecordDetail = (
  data: GetNoticeRecordDetailRequest
): Promise<Response<GetNoticeRecordDetailResponse>> => {
  return apiRequest<GetNoticeRecordDetailResponse>({
    url: "/game/user/GetNoticeRecordDetail",
    method: "post",
    data,
  });
};
